import { Link } from "react-router-dom";

const FOUNDER_IMG = "https://images.unsplash.com/photo-1558981806-ec527fa84c39?crop=entropy&cs=srgb&fm=jpg&q=85";
const GARAGE_IMG = "https://images.unsplash.com/photo-1755541608110-3440a0f168ed?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative h-[60vh] overflow-hidden">
        <img src={FOUNDER_IMG} alt="Founder" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-black/60 to-transparent" />
        <img
          src="/logo.png"
          alt="Bad Girl Customs patch"
          className="absolute top-10 right-10 w-32 md:w-44 opacity-90 hidden md:block"
          data-testid="about-logo-patch"
        />
        <div className="absolute inset-0 max-w-[1400px] mx-auto px-6 lg:px-10 flex items-end pb-16">
          <div>
            <div className="bgc-eyebrow text-[#c8102e]">OUR STORY</div>
            <h1 className="font-display text-6xl md:text-8xl tracking-tight uppercase mt-3">
              Built by Women.<br />
              <span className="text-[#c8102e]">Backed by Steel.</span>
            </h1>
          </div>
        </div>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 py-24 space-y-10 text-lg leading-relaxed text-[#d1d5db]">
        <p>
          {`Bad Girl Customs started in 2019, in a one-car garage in Phoenix, Arizona. Our founder Mara was tired of being told what "girls' parts" looked like — pink, plastic, and shipped from a warehouse that never met a motorcycle. So she bought a lathe.`}
        </p>
        <p>
          {`What began as a single set of bar-end mirrors for her '04 Sportster turned into a waitlist, then a shop, then a brand. Today every mirror that leaves our facility is finished by hand, vibration-tested on a real bike, and packed with a thank-you note from a rider.`}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-6">
          <img src={GARAGE_IMG} alt="Garage" className="w-full aspect-[4/3] object-cover border border-white/10" />
          <img src={FOUNDER_IMG} alt="Founder" className="w-full aspect-[4/3] object-cover border border-white/10" />
        </div>
        <p>
          {`We're still woman-owned, still woman-run, and still a little stubborn. Every dollar gets reinvested into better tooling, better materials, and supporting riders in our community.`}
        </p>
        <div className="grid grid-cols-3 gap-6 py-8 border-y border-white/10">
          {[["12K+", "Riders served"], ["50", "U.S. states shipped"], ["100%", "Woman-owned"]].map(([n, l]) => (
            <div key={l} className="text-center">
              <p className="font-display text-5xl text-[#c8102e]">{n}</p>
              <p className="bgc-eyebrow mt-2">{l}</p>
            </div>
          ))}
        </div>
        <p>
          Want to ride with us? Shop the goods, or drop us a line. We answer every email — sometimes from the workbench.
        </p>
        <div className="flex gap-4">
          <Link to="/shop" className="btn-primary" data-testid="about-shop-cta">SHOP THE COLLECTION</Link>
          <Link to="/contact" className="btn-ghost" data-testid="about-contact-cta">GET IN TOUCH</Link>
        </div>
      </section>
    </div>
  );
}
